var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttherateDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 3.78836,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1710_9964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3411 14.1745C12.906 14.1745 14.1745 12.906 14.1745 11.3411C14.1745 9.77634 12.906 8.50781 11.3411 8.50781C9.77634 8.50781 8.50781 9.77634 8.50781 11.3411C8.50781 12.906 9.77634 14.1745 11.3411 14.1745Z",
    stroke: "#616E85",
    strokeWidth: 1.26666,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1745 8.50782V12.0495C14.1745 12.6131 14.3984 13.1536 14.7969 13.5521C15.1954 13.9506 15.7359 14.1745 16.2995 14.1745C16.8631 14.1745 17.4036 13.9506 17.8021 13.5521C18.2006 13.1536 18.4245 12.6131 18.4245 12.0495V11.3412C18.4245 9.74549 17.8857 8.19658 16.8955 6.94535C15.9052 5.69413 14.5215 4.81391 12.9686 4.4473C11.4156 4.0807 9.78433 4.24918 8.33907 4.92546C6.89381 5.60174 5.71923 6.74619 5.00563 8.17339C4.29203 9.60059 4.08122 11.2269 4.40735 12.7889C4.73348 14.3509 5.57746 15.757 6.80253 16.7794C8.0276 17.8018 9.56199 18.3806 11.1571 18.4221C12.7522 18.4636 14.3146 17.9652 15.5912 17.0078",
    stroke: "#616E85",
    strokeWidth: 1.26666,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1710_9964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(2.8418 2.84082)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttherateDark);
export default __webpack_public_path__ + "static/media/AttherateDark.e70fe67289eeffdd312f664ab44bd6d0.svg";
export { ForwardRef as ReactComponent };